import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { NumberKMPipe } from './../../../../../pipes/numberKMPipe';

@Component({
  selector: 'app-promo-overview-loyalty',
  templateUrl: './overview-loyalty.component.html',
  styleUrls: ['./overview-loyalty.component.css']
})
// Pagina 49
export class PromoOverviewLoyaltyComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public storeError = false;
  public datatablePromo: Array<any>;
  public selectOneError: string;
  public data: QFilterModel;
  public investmentTypePromoColumn: LoyaltyChart;
  public quantityTypePromoColumn: LoyaltyChart;
  public investmentChannelColumn: LoyaltyChart;
  public quantityChannelColumn: LoyaltyChart;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {
    this.translations = {
      investmentTypeAndMec: 'promo.investmentTypeAndMec',
      quantityTypeAndMac: 'promo.quantityTypeAndMac',
      investmentChannel: 'promo.investmentContactChannel',
      quantityContactChannel : 'promo.quantityContactChannel',
      nomePromo: 'store.nomePromo',
      typePromo: 'store.typePromo',
      startPromo: 'store.startPromo',
      endPromo: 'store.endPromo',
      investmentPromo: 'store.investmentPromo',
      associatedExpensePromo: 'store.associatedExpensePromo',
      averageDiscountPromo: 'store.averageDiscountPromo',
      promotionalPressurePromo: 'store.promotionalPressurePromo',
      numberReceiptsPromo: 'store.numberReceiptsPromo',
      customerNumber: 'store.customerNumber'
    };
  }

  ngOnInit() {
    this.initCharts();
  }

  initCharts() {
    this.investmentTypePromoColumn = new LoyaltyChart('column');
    this.investmentTypePromoColumn.options.legend = { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' };  /*Q206*/
    this.investmentTypePromoColumn.options.plotOptions = { column: {stacking: 'normal'} };


    this.investmentTypePromoColumn.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };

    this.investmentTypePromoColumn.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };


    this.quantityTypePromoColumn = new LoyaltyChart('column'); /*Q207*/
    this.quantityTypePromoColumn.options.legend = { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' };  /*Q206*/
    this.quantityTypePromoColumn.options.plotOptions = { column: { stacking: 'normal' } };
    this.quantityTypePromoColumn.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '');
    };
    this.quantityTypePromoColumn.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y);
      }
    };

    this.investmentChannelColumn = new LoyaltyChart('column'); /*q208*/
    this.investmentChannelColumn.options.xAxis = {type: 'category'};
    this.investmentChannelColumn.options.legend.enabled = false;
    this.investmentChannelColumn.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };
    this.investmentChannelColumn.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };

    this.quantityChannelColumn = new LoyaltyChart('column'); /*209*/
    this.quantityChannelColumn.options.xAxis = {type: 'category'};
    this.quantityChannelColumn.options.legend.enabled = false;
    this.quantityChannelColumn.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value);
    };
    this.quantityChannelColumn.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y);
      }
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }


  searchValue(data: QFilterModel) {
    this.data = data;


    this.indicators = [];

    this.indicatorService.indicatorCalculation('promos.Q202', this.data).subscribe(
      q202 => {

        /*202*/
        this.indicators.push(new IndicatorBoxModel([q202.find(r => r.name === 'investimento')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
        /*203*/
        this.indicators.push(new IndicatorBoxModel([q202.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
        /*204*/
        this.indicators.push(new IndicatorBoxModel([q202.find(r => r.name === 'sconto_medio_volantino')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
        /*205*/
        this.indicators.push(new IndicatorBoxModel([q202.find(r => r.name === 'sconto_medio_onetoone')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));

      });


    this.investmentTypePromoColumnInit (data);
    this.quantityTypePromoColumnInit (data);

    this.investmentChannelColumnInit (data);
    this.quantityChannelColumnInit (data);

    this.tableInit (data);
    this.show_results = true;

  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  investmentTypePromoColumnInit (data) {
      this.indicatorService.getChart('promos.Q206', data, false).subscribe( res => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let serie2 = res.series[2].serie;
      const xAxis = {
        serie: serie0.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
      };

      let series: Array<any> = [];
      for (let i = 0; i < serie0.length; i++) {
        let item = series.find(function (elem) {
          return elem.name === serie1[i];
        });

        if (typeof item === 'undefined') {
          series.push({name: serie1[i], data: [serie2[i]]});
        } else {
          item.data.push(serie2[i]);
        }
      }

      let h = series.length * 150 + 10;
      h = h < 350 ? 350 : h;
      this.investmentTypePromoColumn.options.chart.height = h;

      if (this.investmentTypePromoColumn.instance) {
        while (this.investmentTypePromoColumn.instance.series.length > 0) {
          this.investmentTypePromoColumn.instance.series[0].remove(true);
        }
      }

      this.investmentTypePromoColumn.options.xAxis.categories = xAxis.serie;

      for (let i = 0; i < series.length; i++) {
        this.investmentTypePromoColumn.instance.addSeries(series[i]);
      }

      this.investmentTypePromoColumn.instance.update(this.investmentTypePromoColumn.options);
      this.investmentTypePromoColumn.instance.redraw();
    });
  }

  quantityTypePromoColumnInit (data) {
    this.indicatorService.getChart('promos.Q207', data, false).subscribe(res => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let serie2 = res.series[2].serie;
      const xAxis = {
        serie: serie0.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
      };

      let series: Array<any> = [];
      for (let i = 0; i < serie0.length; i++) {
        let item = series.find(function (elem) {
          return elem.name === serie1[i];
        });
        if (typeof item === 'undefined') {
          series.push({name: serie1[i], data: [serie2[i]]});
        } else {
          item.data.push(serie2[i]);
        }
      }

      let h = series.length * 150 + 10;
      h = h < 350 ? 350 : h;
      this.quantityTypePromoColumn.options.chart.height = h;

      if (this.quantityTypePromoColumn.instance) {
        while (this.quantityTypePromoColumn.instance.series.length > 0) {
          this.quantityTypePromoColumn.instance.series[0].remove(true);
        }
      }

      this.quantityTypePromoColumn.options.xAxis.categories = xAxis.serie;

      for (let i = 0; i < series.length; i++) {
        this.quantityTypePromoColumn.instance.addSeries(series[i]);
      }

      this.quantityTypePromoColumn.instance.update(this.quantityTypePromoColumn.options);
      this.quantityTypePromoColumn.instance.redraw();
    });
  }



  investmentChannelColumnInit (data) {

    Observable.zip (
      this.indicatorService.getChart('promos.Q208', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i]} );
      }

      this.investmentChannelColumn.options.chart.height = series.length * 45;

      if (this.investmentChannelColumn.instance) {
        while (this.investmentChannelColumn.instance.series.length > 0) {
          this.investmentChannelColumn.instance.series[0].remove(true);
        }
      }


      this.investmentChannelColumn.options.series = [{ name: '', colorByPoint: true, data: series }];
      this.investmentChannelColumn.options.chart.height = 350;
      this.investmentChannelColumn.instance.addSeries(series);

      this.investmentChannelColumn.instance.update(this.investmentChannelColumn.options);
      this.investmentChannelColumn.instance.redraw();

    });
  }
  quantityChannelColumnInit (data) {

    Observable.zip (
      this.indicatorService.getChart('promos.Q209', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i]} );
      }

      let h = series.length * 45;
      h = h < 350 ? 350 : h;
      this.quantityChannelColumn.options.chart.height = h;

      if (this.quantityChannelColumn.instance) {
        while (this.quantityChannelColumn.instance.series.length > 0) {
          this.quantityChannelColumn.instance.series[0].remove(true);
        }
      }


      this.quantityChannelColumn.options.series = [{ name: '', colorByPoint: true, data: series }];
      this.quantityChannelColumn.options.chart.height = 350;
      this.quantityChannelColumn.instance.addSeries(series);

      this.quantityChannelColumn.instance.update(this.quantityChannelColumn.options);
      this.quantityChannelColumn.instance.redraw();
    });
  }

  public tableInit (data: QFilterModel) {
    this.indicatorService.getChart('promos.Q210', data).subscribe((resp) => {

      this.datatablePromo = [];
      if (resp.series.length > 0) {
        let serie0  = resp.series[0].serie;
        let serie1  = resp.series[1].serie;
        let serie2  = resp.series[2].serie;
        let serie3  = resp.series[3].serie;
        let serie4  = resp.series[4].serie;
        let serie6  = resp.series[6].serie;
        let serie8  = resp.series[8].serie;
        let serie10 = resp.series[10].serie;
        let serie11 = resp.series[11].serie;
        let serie12 = resp.series[12].serie;
        for (let i = 0; i < serie0.length; i++) {

          this.datatablePromo.push({
            nomePromo:                  serie1[i],
            typePromo:                  serie0[i],
            startPromo:                 serie2[i],
            endPromo:                   serie3[i],
            investmentPromo:            serie4[i],
            associatedExpensePromo:     serie6[i],
            averageDiscountPromo:       serie8[i],
            promotionalPressurePromo:   serie10[i],
            numberReceiptsPromo:        serie11[i],
            customerNumber:             serie12[i]
          });
        }
      }

    });
  }

  resetData() {
    this.show_results = false;
  }

  public formatNumber (n, digit = 2) {
    let newN = n;
    if (newN < 1000) {
      newN = n.toFixed(2).toString ();
    } else if (n < 1000000) {
      newN = (n / 1000).toFixed(digit).toString () + ' k';
    } else {
      newN = (n / 1000000).toFixed(digit).toString () + ' M';
    }
    return newN;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/overview-loyalty/overview-loyalty.component.ts